import { Directive, Input, HostListener } from '@angular/core';

import { MatomoTrackerService } from '../services/matomo-tracker.service';

@Directive({
    selector: '[aaTrackerEvent]',
    standalone: false
})
export class TrackerEventDirective
{
    @Input() trackerCategory: string;
    @Input() trackerAction: string;
    @Input() trackerLabel: string;

    constructor(
        private matomoTrackerService: MatomoTrackerService
    ) { }

    @HostListener('click')
    onClick ()
    {
        this.matomoTrackerService.trackEvent(this.trackerCategory, this.trackerAction, this.trackerLabel);
    }
}
